import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ProductCard } from '../components/ProductCard';
import { FilterIcon, ChevronDownIcon, SearchIcon, XIcon } from 'lucide-react';
// Sample product data with real flower images
const products = [{
  id: '1',
  name: 'Elegant Rose Bouquet',
  price: 3500,
  image: 'https://images.unsplash.com/photo-1548094990-c16ca90f1f0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets',
  isNew: true
}, {
  id: '2',
  name: 'Peaceful Lily Plant',
  price: 2800,
  image: 'https://images.unsplash.com/photo-1567748157439-651aca2ff064?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants'
}, {
  id: '3',
  name: 'Sunshine Sunflower Arrangement',
  price: 4200,
  image: 'https://images.unsplash.com/photo-1470509037663-253afd7f0f51?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Arrangements',
  isBestseller: true
}, {
  id: '4',
  name: 'Exotic Orchid Collection',
  price: 6500,
  image: 'https://images.unsplash.com/photo-1589994160839-163cd867cfe8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Exotic'
}, {
  id: '5',
  name: 'Vibrant Tulip Mix',
  price: 3800,
  image: 'https://images.unsplash.com/photo-1520763185298-1b434c919102?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets'
}, {
  id: '6',
  name: 'Succulent Garden',
  price: 4800,
  image: 'https://images.unsplash.com/photo-1446071103084-c257b5f70672?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants',
  isNew: true
}, {
  id: '7',
  name: 'Classic Carnation Bundle',
  price: 2900,
  image: 'https://images.unsplash.com/photo-1487530811176-3780de880c2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets'
}, {
  id: '8',
  name: 'Hanging Pothos Plant',
  price: 3600,
  image: 'https://images.unsplash.com/photo-1592170577795-32065ae195e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants',
  isBestseller: true
}, {
  id: '9',
  name: 'Fragrant Lavender Pot',
  price: 3200,
  image: 'https://images.unsplash.com/photo-1469259943454-aa100abba749?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants'
}, {
  id: '10',
  name: 'Romantic Mixed Bouquet',
  price: 4500,
  image: 'https://images.unsplash.com/photo-1591710668263-bee1e9db2a26?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Bouquets'
}, {
  id: '11',
  name: 'Monstera Deliciosa',
  price: 5200,
  image: 'https://images.unsplash.com/photo-1614594975525-e45190c55d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Plants'
}, {
  id: '12',
  name: 'Seasonal Wildflower Mix',
  price: 3900,
  image: 'https://images.unsplash.com/photo-1563241527-3004b7be0ffd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  category: 'Arrangements'
}];
// Categories for filtering
const categories = [{
  name: 'All',
  value: 'all'
}, {
  name: 'Bouquets',
  value: 'Bouquets'
}, {
  name: 'Plants',
  value: 'Plants'
}, {
  name: 'Arrangements',
  value: 'Arrangements'
}, {
  name: 'Exotic',
  value: 'Exotic'
}];
// Sort options
const sortOptions = [{
  name: 'Newest',
  value: 'newest'
}, {
  name: 'Price: Low to High',
  value: 'price-asc'
}, {
  name: 'Price: High to Low',
  value: 'price-desc'
}];
export function Shop() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('newest');
  const [searchQuery, setSearchQuery] = useState('');
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  // Filter products based on category and search query
  const filteredProducts = products.filter(product => {
    const matchesCategory = selectedCategory === 'all' || product.category === selectedCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase()) || product.category.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  // Sort products
  const sortedProducts = [...filteredProducts].sort((a, b) => {
    if (sortBy === 'price-asc') return a.price - b.price;
    if (sortBy === 'price-desc') return b.price - a.price;
    // Default to newest (by id as a proxy in this example)
    return parseInt(b.id) - parseInt(a.id);
  });
  return <div className="min-h-screen flex flex-col" data-id="element-1068">
      <Header data-id="element-1069" />
      <main className="flex-grow" data-id="element-1070">
        {/* Hero section */}
        <div className="bg-emerald-700 text-white py-12" data-id="element-1071">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1072">
            <h1 className="text-3xl font-bold mb-4" data-id="element-1073">Shop Our Collection</h1>
            <p className="text-emerald-100 max-w-3xl" data-id="element-1074">
              Browse our handpicked selection of beautiful flowers, plants, and
              arrangements. Perfect for any occasion or to brighten up your
              space.
            </p>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1075">
          {/* Filters and Search */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 space-y-4 md:space-y-0" data-id="element-1076">
            <div className="flex flex-wrap items-center gap-2" data-id="element-1077">
              <button onClick={() => setMobileFiltersOpen(true)} className="md:hidden bg-white p-2 rounded-md border border-gray-300 flex items-center text-sm font-medium text-gray-700" data-id="element-1078">
                <FilterIcon className="h-4 w-4 mr-1" data-id="element-1079" /> Filters
              </button>
              <div className="hidden md:flex items-center space-x-2" data-id="element-1080">
                <span className="text-sm font-medium text-gray-700" data-id="element-1081">
                  Category:
                </span>
                <div className="relative" data-id="element-1082">
                  <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} className="appearance-none bg-white border border-gray-300 rounded-md py-2 pl-3 pr-8 text-sm focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-1083">
                    {categories.map(category => <option key={category.value} value={category.value} data-id="element-1084">
                        {category.name}
                      </option>)}
                  </select>
                  <ChevronDownIcon className="h-4 w-4 text-gray-500 absolute right-2 top-1/2 transform -translate-y-1/2" data-id="element-1085" />
                </div>
              </div>
              <div className="hidden md:flex items-center space-x-2 ml-4" data-id="element-1086">
                <span className="text-sm font-medium text-gray-700" data-id="element-1087">
                  Sort by:
                </span>
                <div className="relative" data-id="element-1088">
                  <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="appearance-none bg-white border border-gray-300 rounded-md py-2 pl-3 pr-8 text-sm focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-1089">
                    {sortOptions.map(option => <option key={option.value} value={option.value} data-id="element-1090">
                        {option.name}
                      </option>)}
                  </select>
                  <ChevronDownIcon className="h-4 w-4 text-gray-500 absolute right-2 top-1/2 transform -translate-y-1/2" data-id="element-1091" />
                </div>
              </div>
            </div>
            <div className="relative w-full md:w-64" data-id="element-1092">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1093">
                <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-1094" />
              </div>
              <input type="text" placeholder="Search products..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm placeholder-gray-500 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500" data-id="element-1095" />
              {searchQuery && <button onClick={() => setSearchQuery('')} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1096">
                  <XIcon className="h-4 w-4 text-gray-400 hover:text-gray-600" data-id="element-1097" />
                </button>}
            </div>
          </div>
          {/* Mobile filters dialog */}
          {mobileFiltersOpen && <div className="fixed inset-0 z-40 flex md:hidden" data-id="element-1098">
              <div className="fixed inset-0 bg-black bg-opacity-25" onClick={() => setMobileFiltersOpen(false)} data-id="element-1099" />
              <div className="relative max-w-xs w-full h-full bg-white shadow-xl py-4 pb-12 flex flex-col overflow-y-auto" data-id="element-1100">
                <div className="px-4 flex items-center justify-between" data-id="element-1101">
                  <h2 className="text-lg font-medium text-gray-900" data-id="element-1102">Filters</h2>
                  <button type="button" className="-mr-2 w-10 h-10 p-2 flex items-center justify-center text-gray-400 hover:text-gray-500" onClick={() => setMobileFiltersOpen(false)} data-id="element-1103">
                    <XIcon className="h-6 w-6" data-id="element-1104" />
                  </button>
                </div>
                <div className="mt-4 border-t border-gray-200" data-id="element-1105">
                  <div className="px-4 py-6" data-id="element-1106">
                    <h3 className="text-sm font-medium text-gray-900" data-id="element-1107">
                      Category
                    </h3>
                    <div className="mt-4 space-y-2" data-id="element-1108">
                      {categories.map(category => <div key={category.value} className="flex items-center" data-id="element-1109">
                          <input id={`category-${category.value}`} name="category" value={category.value} type="radio" checked={selectedCategory === category.value} onChange={() => setSelectedCategory(category.value)} className="h-4 w-4 border-gray-300 text-emerald-600 focus:ring-emerald-500" data-id="element-1110" />
                          <label htmlFor={`category-${category.value}`} className="ml-3 text-sm text-gray-600" data-id="element-1111">
                            {category.name}
                          </label>
                        </div>)}
                    </div>
                  </div>
                  <div className="px-4 py-6 border-t border-gray-200" data-id="element-1112">
                    <h3 className="text-sm font-medium text-gray-900" data-id="element-1113">
                      Sort by
                    </h3>
                    <div className="mt-4 space-y-2" data-id="element-1114">
                      {sortOptions.map(option => <div key={option.value} className="flex items-center" data-id="element-1115">
                          <input id={`sort-${option.value}`} name="sort" value={option.value} type="radio" checked={sortBy === option.value} onChange={() => setSortBy(option.value)} className="h-4 w-4 border-gray-300 text-emerald-600 focus:ring-emerald-500" data-id="element-1116" />
                          <label htmlFor={`sort-${option.value}`} className="ml-3 text-sm text-gray-600" data-id="element-1117">
                            {option.name}
                          </label>
                        </div>)}
                    </div>
                  </div>
                </div>
                <div className="px-4 py-4 border-t border-gray-200 mt-auto" data-id="element-1118">
                  <button className="w-full bg-emerald-600 text-white py-2 px-4 rounded-md hover:bg-emerald-700 transition-colors" onClick={() => setMobileFiltersOpen(false)} data-id="element-1119">
                    Apply Filters
                  </button>
                </div>
              </div>
            </div>}
          {/* Results count */}
          <div className="mb-6" data-id="element-1120">
            <p className="text-sm text-gray-500" data-id="element-1121">
              Showing {sortedProducts.length}{' '}
              {sortedProducts.length === 1 ? 'result' : 'results'}
              {selectedCategory !== 'all' && ` in ${selectedCategory}`}
              {searchQuery && ` for "${searchQuery}"`}
            </p>
          </div>
          {/* Product grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-10" data-id="element-1122">
            {sortedProducts.map(product => <ProductCard key={product.id} id={product.id} name={product.name} price={product.price} image={product.image} category={product.category} isNew={product.isNew} isBestseller={product.isBestseller} data-id="element-1123" />)}
          </div>
          {/* Empty state */}
          {sortedProducts.length === 0 && <div className="text-center py-12" data-id="element-1124">
              <p className="text-lg text-gray-500 mb-4" data-id="element-1125">No products found</p>
              <p className="text-sm text-gray-400" data-id="element-1126">
                Try adjusting your filters or search term
              </p>
              <button onClick={() => {
            setSelectedCategory('all');
            setSearchQuery('');
          }} className="mt-4 text-emerald-600 hover:text-emerald-700" data-id="element-1127">
                Clear all filters
              </button>
            </div>}
        </div>
      </main>
      <Footer data-id="element-1128" />
    </div>;
}